import React, { Component } from 'react'
import './index.less'

export default class extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let { lang, rwState } = this.props
    let rewardList = [
      {
        list: [
          {
            title: lang.no1,
            list: [
              { pic: '/img/activity/monthlyRank/sp/wealth_sp.png', title: lang.spegift },
              { pic: '/img/activity/monthlyRank/sp/show.png', title: lang.show },
              { pic: '/img/activity/monthlyRank/medal/2/wealth1.png', title: lang.perMedal },
              { pic: '/img/activity/monthlyRank/car/2/wealth1.png', title: lang.car },
              { pic: '/img/activity/monthlyRank/head/2/wealth1.png', title: lang.head },
              { pic: '/img/activity/monthlyRank/sp/wealth_medal.png', title: lang.sp },
            ]
          },
          {
            title: lang.no2,
            list: [
              { pic: '/img/activity/monthlyRank/medal/2/wealth2.png', title: lang.perMedal },
              { pic: '/img/activity/monthlyRank/car/2/wealth2.png', title: lang.car },
              { pic: '/img/activity/monthlyRank/head/2/wealth2.png', title: lang.head },
            ]
          },
          {
            title: lang.no3,
            list: [
              { pic: '/img/activity/monthlyRank/medal/2/wealth3.png', title: lang.perMedal },
              { pic: '/img/activity/monthlyRank/car/2/wealth3.png', title: lang.car },
              { pic: '/img/activity/monthlyRank/head/2/wealth3.png', title: lang.head },
            ]
          },
        ]
      },
      {
        list: [
          {
            title: lang.no1,
            desc: '',
            list: [
              { pic: '/img/activity/monthlyRank/sp/charm_sp.png', title: lang.spegift },
              { pic: '/img/activity/monthlyRank/medal/3/charm1.png', title: lang.perMedal },
              { pic: '/img/activity/monthlyRank/car/3/charm1.png', title: lang.car },
              { pic: '/img/activity/monthlyRank/head/3/charm1.png', title: lang.head },
              { pic: '/img/activity/monthlyRank/sp/charm_medal.png', title: lang.sp },
            ]
          },
          {
            title: lang.no2,
            list: [
              { pic: '/img/activity/monthlyRank/medal/3/charm2.png', title: lang.perMedal },
              { pic: '/img/activity/monthlyRank/car/3/charm2.png', title: lang.car },
              { pic: '/img/activity/monthlyRank/head/3/charm2.png', title: lang.head },
            ]
          },
          {
            title: lang.no3,
            list: [
              { pic: '/img/activity/monthlyRank/medal/3/charm3.png', title: lang.perMedal },
              { pic: '/img/activity/monthlyRank/car/3/charm3.png', title: lang.car },
              { pic: '/img/activity/monthlyRank/head/3/charm3.png', title: lang.head },
            ]
          },
        ]
      },
      {
        list: [
          {
            title: lang.no1,
            list: [
              { pic: '/img/activity/monthlyRank/medal/4/room1.png', title: lang.mMedal }
            ]
          },
          {
            title: lang.no2,
            list: [
              { pic: '/img/activity/monthlyRank/medal/4/room2.png', title: lang.mMedal }
            ]
          },
          {
            title: lang.no3,
            list: [
              { pic: '/img/activity/monthlyRank/medal/4/room3.png', title: lang.mMedal }
            ]
          },
        ]
      },
    ]


    return (
      <div className={`mmr-reward-wrap`}>
        <div className="reward-top">
          {lang.rw}
        </div>
        <div className={`reward-center`}>
          {
            rewardList[rwState - 1].list.map((items, index) => {
              return (
                <div className={`reward-item`} key={index}>
                  <div className="r-title-bg">
                    {items.title}
                  </div>
                  {/* <div className="desc" dangerouslySetInnerHTML={{ __html: items.desc }}></div> */}
                  {/* 勋章占位 */}
                  <div
                    style={{
                      width: `${items.desc == "" ? "5.5rem" : ""}`,
                      margin: `${items.desc == "" ? "0 auto" : ""}`,
                    }}
                    className="r-main">
                    {
                      items.list.map((item3, index) => {
                        return (
                          <div className="item" key={index}>
                            <div
                              className={`item-bg ${item3.pic == "/img/activity/monthlyRank/sp/show.png" ||
                                item3.pic == "/img/activity/monthlyRank/sp/wealth_sp.png" ||
                                item3.pic == "/img/activity/monthlyRank/sp/charm_sp.png" ? "sp_pic" : ""}`}>
                              <img src={item3.pic} alt="" />
                            </div>
                            <div className="item-name" dangerouslySetInnerHTML={{ __html: item3.title }}></div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              )
            })
          }

        </div>
        <div className="reward-bottom"></div>
      </div>
    )
  }
}

// 勋章模块
{/* <div className="r-medal">
    <div className="r-medal-box-wrap">
      <div className="r-medal-box">
        <img src={item.mainMedal.medalPic} />
      </div>
      <div className="medal-name">{item.mainMedal.title}</div>
    </div>
    <div className="r-medal-rank">
      <div className="title">{item.desc}</div>
      <div className="medal-item-wrap">
        {
          item.medalList.map((item2, index) => {
            return (
              <div className="medal-item" key={index}>
                <img src={item2.medalPic} />
              </div>
            )
          })
        }
      </div>
    </div>
</div> 

// 数据格式
[
  {
    title: lang.no1,
    desc: lang.medalDesc,
    mainMedal: { medalPic: '/img/activity/monthlyRank/banner.png', title: '勋章' },
    medalList: [
      { medalPic: '/img/activity/monthlyRank/banner.png' },
      { medalPic: '/img/activity/monthlyRank/banner.png' },
      { medalPic: '/img/activity/monthlyRank/banner.png' }
    ],
    list: [
      { pic: '/img/activity/monthlyRank/banner.png', title: 'xxx' }
    ]
  }
]

*/}



// WEBPACK FOOTER //
// src/pages/activity/monthly-rank/rewardComp/index.js